<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="reject()">
        {{ data.rejectLabel }}
    </button>
    <button mat-stroked-button color="primary" (click)="accept()">
        {{ data.acceptLabel }}
    </button>
</div>
